import template from './template.html';
import navigationItem from '../navigation-item';

export default {
    name: 'navigation',
    template: template,
    components: {
        navigationItem,
    },
    props: {
        items: Array,
        wrapItem: Boolean,
    }
};
